import ErrorMessage, {
  ErrorMessageProps,
} from 'approot/shared/error-message/error-message';
import { AnchorLinkErrorStyled } from 'approot/shared/styles/typography.style';
import { PUBLIC_CONTACT_US } from 'global/public-routes.constants';

type InlineServerErrorProps = {
  customError?: string;
} & ErrorMessageProps;

const InlineServerError = ({
  customError,
  ...props
}: InlineServerErrorProps) => {
  return customError ? (
    <ErrorMessage {...props}>{customError}</ErrorMessage>
  ) : (
    <ErrorMessage {...props}>
      Something went wrong, please try again or{' '}
      <AnchorLinkErrorStyled to={PUBLIC_CONTACT_US}>
        contact us
      </AnchorLinkErrorStyled>
    </ErrorMessage>
  );
};

export default InlineServerError;
